const COLOR_MODE_KEY = 'color-mode';

function getSystemColorMode() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function getStoredColorMode() {
  try {
    const stored = localStorage.getItem(COLOR_MODE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch (error) {
    // localStorage may be unavailable
  }
  return null;
}

function resolveColorMode() {
  return getStoredColorMode() || getSystemColorMode();
}

const PREORDER_NOTE_RE = /envio realizado após|atente-se ao prazo/i;

function clearPreorderNoteStyles(el) {
  el.style.removeProperty('color');
  el.style.removeProperty('-webkit-text-fill-color');
  el.style.removeProperty('opacity');
  el.removeAttribute('data-preorder-note-contrast');
}

function restylePreorderNotes() {
  const isDark = document.documentElement.getAttribute('data-color-mode') === 'dark';

  document.querySelectorAll('[data-preorder-note-contrast]').forEach((el) => {
    if (!isDark) clearPreorderNoteStyles(el);
  });

  if (!isDark) return;

  document.querySelectorAll('.product__info-container p, .product__info-container span, .product__info-container small, .product-form p, .product-form span, .product-form small').forEach((el) => {
    if (el.closest('button, a, .product__description, .product-form__submit')) return;
    if (el.querySelector('button, .button, .product-form__submit')) return;

    const ownText = [...el.childNodes]
      .filter((node) => node.nodeType === Node.TEXT_NODE)
      .map((node) => node.textContent)
      .join(' ')
      .trim();
    const text = ownText || (el.children.length === 0 ? (el.textContent || '').trim() : '');
    if (!PREORDER_NOTE_RE.test(text) || text.length > 400) return;

    el.style.setProperty('color', '#e8e8e8', 'important');
    el.style.setProperty('-webkit-text-fill-color', '#e8e8e8', 'important');
    el.style.setProperty('opacity', '1', 'important');
    el.setAttribute('data-preorder-note-contrast', '');
  });
}

function applyColorMode(mode) {
  document.documentElement.setAttribute('data-color-mode', mode);
  document.documentElement.style.colorScheme = mode;

  const metaThemeColor = document.querySelector('meta[name="theme-color"]');
  if (metaThemeColor) {
    const background = getComputedStyle(document.documentElement)
      .getPropertyValue('--color-background')
      .trim();
    if (background) {
      metaThemeColor.setAttribute('content', `rgb(${background})`);
    }
  }

  document.querySelectorAll('theme-mode-toggle').forEach((toggle) => {
    toggle.update(mode);
  });

  restylePreorderNotes();
}

function setColorMode(mode) {
  try {
    localStorage.setItem(COLOR_MODE_KEY, mode);
  } catch (error) {
    // localStorage may be unavailable
  }
  applyColorMode(mode);
}

function toggleColorMode() {
  const next = resolveColorMode() === 'dark' ? 'light' : 'dark';
  setColorMode(next);
}

class ThemeModeToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.moonIcon = this.querySelector('.theme-mode-toggle__icon--moon');
    this.sunIcon = this.querySelector('.theme-mode-toggle__icon--sun');
    if (!this.button) return;

    this.button.addEventListener('click', toggleColorMode);
    this.update(resolveColorMode());
  }

  update(mode) {
    if (!this.button) return;

    const isDark = mode === 'dark';
    this.moonIcon?.classList.toggle('hidden', isDark);
    this.sunIcon?.classList.toggle('hidden', !isDark);

    const label = isDark ? this.button.dataset.labelLight : this.button.dataset.labelDark;
    this.button.setAttribute('aria-label', label);
    this.button.setAttribute('aria-pressed', isDark ? 'true' : 'false');
  }
}

customElements.define('theme-mode-toggle', ThemeModeToggle);

applyColorMode(resolveColorMode());

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
  if (getStoredColorMode()) return;
  applyColorMode(getSystemColorMode());
});

let preorderNoteTimer;
function schedulePreorderNoteRestyle() {
  clearTimeout(preorderNoteTimer);
  preorderNoteTimer = setTimeout(restylePreorderNotes, 50);
}

const preorderNoteObserver = new MutationObserver(schedulePreorderNoteRestyle);
const preorderObserveRoot =
  document.querySelector('.product__info-container, product-form, .product-form') || document.body;

preorderNoteObserver.observe(preorderObserveRoot, { childList: true, subtree: true });
document.addEventListener('DOMContentLoaded', restylePreorderNotes);
